import { adminT } from '@/i18n/adminCommon'

export const GEO_DATA_REVISION_MESSAGES = {
  de: {
    title: 'Geo-Daten Abgleich',
    intro: 'Geo-Daten von Accounts und/oder Contacts per Google Geocoding ergänzen.',
    prerequisites: 'Voraussetzungen:',
    prereqAddress: 'Halbwegs vollständige Adresse (Straße, PLZ, Stadt, Länderkürzel)',
    prereqApproved: 'Entity ist approved',
    prereqIncomplete: 'Geo-Daten noch unvollständig (longitude und/oder latitude leer)',
    note: 'Neue Koordinaten werden revisionssicher als Change gespeichert. Für ANW-Partnerstandorte: Entity-Typ Contacts wählen.',
    entity: 'Entity',
    entityAccount: 'Accounts',
    entityContact: 'Contacts',
    entityBoth: 'Beide',
    group: 'Gruppe',
    year: 'Jahr',
    optional: 'optional',
    groupHelp: 'Aus der Projektliste wählen oder Kürzel eingeben. Nur zusammen mit Jahr, sonst leer lassen (global).',
    yearHelp: 'Vierstelliges Jahr (1900–2100). Nur zusammen mit Gruppe, sonst leer lassen.',
    limitHelp: 'Maximale Anzahl Zeilen für Debug Qualification.',
    targetSet: 'Zielmenge',
    missingOnly: 'Nur fehlende',
    allSelected: 'Alle (gewählter Typ)',
    limit: 'Limit',
    limitRule: 'Limit muss größer als 0 sein',
    validationGroupRequired: 'Gruppe fehlt – Jahr und Gruppe gehören zusammen.',
    validationYearRequired: 'Jahr fehlt – Gruppe und Jahr gehören zusammen.',
    validationYearFormat: 'Bitte ein gültiges Jahr als 4 Ziffern eingeben (1900–2100).',
    validationGroupUnknown: 'Kürzel nicht in der Projektliste – freie Eingabe wird trotzdem verwendet.',
    validationScopePair: 'Scope: entweder Gruppe und Jahr zusammen, oder beide leer (global).',
    loadOverview: 'Übersicht laden',
    reviseGeo: 'Geo-Daten abgleichen',
    debugQualification: 'Debug Qualification',
    'metric.account.total': 'Accounts gesamt',
    'metric.account.missing': 'Accounts ohne GeoDaten gesamt',
    'metric.account.qualified_missing': 'Accounts ohne GeoDaten, Abgleich möglich',
    'metric.account.unqualified_missing': 'Accounts ohne GeoDaten, Abgleich nicht möglich',
    'metric.contact.total': 'Contacts gesamt',
    'metric.contact.missing': 'Contacts ohne GeoDaten gesamt',
    'metric.contact.qualified_missing': 'Contacts ohne GeoDaten, Abgleich möglich',
    'metric.contact.unqualified_missing': 'Contacts ohne GeoDaten, Abgleich nicht möglich',
    colType: 'Typ',
    colId: 'ID',
    colApproved: 'Approved',
    colZip: 'PLZ',
    colCity: 'Stadt',
    colCountryCode: 'Ländercode',
    colStreet: 'Straße',
    colLat: 'Lat',
    colLng: 'Lng',
    debugEmpty: 'Keine Debug-Daten gefunden (prüfe Scope/Limit/Entity).',
    dryRunTitle: 'Dry-Run Ergebnis',
    importTitle: 'Import-Ergebnis',
    scope: 'Scope',
    groupLabel: 'Gruppe',
    yearLabel: 'Jahr',
    accounts: 'Accounts',
    contacts: 'Contacts',
    counts: 'Counts',
    total: 'Total',
    missing: 'Missing',
    willProcess: 'Wird verarbeitet',
    missingOnlyHint: '(nur fehlende, Abgleich möglich)',
    allEntitiesHint: '(alle gewählten Entities)',
    importHint: 'Hinweis: Beim Import (dry_run=0) werden die Geo-Daten geschrieben.',
    dryRunFailed: 'Dry-Run fehlgeschlagen',
    unknownError: 'Unbekannter Fehler',
    importRunning: 'Import läuft … Ergebnisse werden fortlaufend angezeigt.',
    colStatus: 'Status',
    colMessage: 'Nachricht',
    rows: 'Zeilen',
    import: 'Importieren'
  },
  en: {
    title: 'Geo data revision',
    intro: 'Enrich Account and/or Contact geo data via Google Geocoding.',
    prerequisites: 'Requirements:',
    prereqAddress: 'Reasonably complete address (street, ZIP, city, country code)',
    prereqApproved: 'Entity is approved',
    prereqIncomplete: 'Geo data still incomplete (longitude and/or latitude empty)',
    note: 'New coordinates are stored as a revision-safe Change. For ANW partner locations: choose entity type Contacts.',
    entity: 'Entity',
    entityAccount: 'Accounts',
    entityContact: 'Contacts',
    entityBoth: 'Both',
    group: 'Group',
    year: 'Year',
    optional: 'optional',
    groupHelp: 'Pick from the project list or type a short code. Use with year, or leave both empty (global).',
    yearHelp: 'Four-digit year (1900–2100). Use with group, or leave both empty.',
    limitHelp: 'Maximum rows returned by Debug qualification.',
    targetSet: 'Target set',
    missingOnly: 'Missing only',
    allSelected: 'All (selected type)',
    limit: 'Limit',
    limitRule: 'Limit must be greater than 0',
    validationGroupRequired: 'Group is missing — group and year must be used together.',
    validationYearRequired: 'Year is missing — group and year must be used together.',
    validationYearFormat: 'Enter a valid 4-digit year (1900–2100).',
    validationGroupUnknown: 'Short code is not in the project list — free text will still be used.',
    validationScopePair: 'Scope: set group and year together, or leave both empty (global).',
    loadOverview: 'Load overview',
    reviseGeo: 'Revise geo data',
    debugQualification: 'Debug qualification',
    'metric.account.total': 'Total accounts',
    'metric.account.missing': 'Accounts missing geodata',
    'metric.account.qualified_missing': 'Accounts missing geodata, eligible',
    'metric.account.unqualified_missing': 'Accounts missing geodata, not eligible',
    'metric.contact.total': 'Total contacts',
    'metric.contact.missing': 'Contacts missing geodata',
    'metric.contact.qualified_missing': 'Contacts missing geodata, eligible',
    'metric.contact.unqualified_missing': 'Contacts missing geodata, not eligible',
    colType: 'Type',
    colId: 'ID',
    colApproved: 'Approved',
    colZip: 'ZIP',
    colCity: 'City',
    colCountryCode: 'Country code',
    colStreet: 'Street',
    colLat: 'Lat',
    colLng: 'Lng',
    debugEmpty: 'No debug data found (check scope/limit/entity).',
    dryRunTitle: 'Dry-run result',
    importTitle: 'Import result',
    scope: 'Scope',
    groupLabel: 'Group',
    yearLabel: 'Year',
    accounts: 'Accounts',
    contacts: 'Contacts',
    counts: 'Counts',
    total: 'Total',
    missing: 'Missing',
    willProcess: 'Will process',
    missingOnlyHint: '(missing only, eligible for revision)',
    allEntitiesHint: '(all selected entities)',
    importHint: 'Note: Import (dry_run=0) writes the geo data.',
    dryRunFailed: 'Dry-run failed',
    unknownError: 'Unknown error',
    importRunning: 'Import running… Results appear as they arrive.',
    colStatus: 'Status',
    colMessage: 'Message',
    rows: 'Rows',
    import: 'Import'
  }
}

export function geoDataRevisionT (lang, key) {
  return adminT(GEO_DATA_REVISION_MESSAGES, lang, key)
}
